import EmployeeEmploymentOrganizationStructureComponents from "../components/EmployeeEmploymentOrganizationStructure";
import useEmployeeEmploymentOrganizationStructure from "../hooks/useEmployeeEmploymentOrganizationStructure";

function EmployeeEmploymentOrganizationStructure() {
  const organizationStructure =
    useEmployeeEmploymentOrganizationStructure();
  return (
    <EmployeeEmploymentOrganizationStructureComponents
      {...organizationStructure}
    />
  );
}

export default EmployeeEmploymentOrganizationStructure;
